import React from 'react';
import './modal.css';
import imacDomvs from '../../assets/img/nuclear.png';
import imacToniolo from '../../assets/img/hospital.png';
import video from '../../assets/img/videoplayer.png';

import Anurag from '../../assets/img/Anurag.png';
import INNOVESIA from '../../assets/img/INNOVESIA.png';
import VJIT from '../../assets/img/VJIT.png';
import SUDHEE from '../../assets/img/SUDHEE.png';
import CN from '../../assets/img/CN.png';
import Turingcup from '../../assets/img/Turing_cup.png';
import Gokaraj from '../../assets/img/Gokaraju_Hackathon.png';
import APJC from '../../assets/img/APJC_Netacad_Cisco.png';
import ZARC from '../../assets/img/ZARC.png';
import GITHUB from '../../assets/img/CSI.png';
import CBIT from '../../assets/img/CBIT.png';
import Certificate from '../../assets/img/C++.png';

import { i18n } from '../MultiLingue/Translate/i18n';

export const ModalContent1 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('projects.modal1.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="video" src={video} />
        </div>

        <div className="project-info">
          <h3>{i18n.t('projects.modal1.titleContent')}</h3>
          <p>{i18n.t('projects.modal1.content')}</p>
          <h4>{i18n.t('projects.modal1.techTitle')}</h4>
          <div className="tech-list">
            <ul className="col">
              <li>{i18n.t('projects.modal1.techList.one')}</li>
              <li>{i18n.t('projects.modal1.techList.four')}</li>
            </ul>
            <ul className="col">
              <li>{i18n.t('projects.modal1.techList.two')}</li>
              <li>{i18n.t('projects.modal1.techList.five')}</li>
            </ul>
            <ul className="col">
              <li>{i18n.t('projects.modal1.techList.three')}</li>
              <li>{i18n.t('projects.modal1.techList.six')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ModalContent2 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('projects.modal2.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="im" src={imacToniolo} />
        </div>

        <div className="project-info">
          <h3>{i18n.t('projects.modal2.titleContent')}</h3>
          <p>{i18n.t('projects.modal2.content')}</p>
          <h4>{i18n.t('projects.modal2.techTitle')}</h4>
          <div className="tech-list">
            <ul className="col">
              <li>{i18n.t('projects.modal2.techList.one')}</li>
              <li>{i18n.t('projects.modal2.techList.four')}</li>
            </ul>
            <ul className="col">
              <li>{i18n.t('projects.modal2.techList.two')}</li>
              <li>{i18n.t('projects.modal2.techList.five')}</li>
            </ul>
            <ul className="col">
              <li>{i18n.t('projects.modal2.techList.three')}</li>
              <li>{i18n.t('projects.modal2.techList.six')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ModalContent3 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('projects.modal3.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="imac" src={imacDomvs} />
        </div>

        <div className="project-info">
          <h3>{i18n.t('projects.modal3.titleContent')}</h3>
          <p>{i18n.t('projects.modal3.content')}</p>
          <h4>{i18n.t('projects.modal3.techTitle')}</h4>
          <div className="tech-list">
            <ul className="col">
              <li>{i18n.t('projects.modal3.techList.one')}</li>
              <li>{i18n.t('projects.modal3.techList.four')}</li>
            </ul>
            <ul className="col">
              <li>{i18n.t('projects.modal3.techList.two')}</li>
              <li>{i18n.t('projects.modal3.techList.five')}</li>
            </ul>
            <ul className="col">
              <li>{i18n.t('projects.modal3.techList.three')}</li>
              <li>{i18n.t('projects.modal3.techList.six')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate1 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal1.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="jdb" src={Gokaraj} />
        </div>
      </div>
    </div>
  );
};
export const ModalCertificate2 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal2.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="jsb" src={APJC} />
        </div>
      </div>
    </div>
  );
};
export const ModalCertificate3 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal3.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="nscj" src={Turingcup} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate4 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal4.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img alt="sbdc" src={Anurag} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate5 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal5.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={INNOVESIA} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate6 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal6.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={CBIT} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate7 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal7.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={SUDHEE} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate8 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal8.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={VJIT} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate9 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal9.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={CN} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate10 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal10.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={ZARC} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate11 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal11.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={GITHUB} />
        </div>
      </div>
    </div>
  );
};

export const ModalCertificate12 = () => {
  return (
    <div className="conteudo-modal">
      <h2 className="titulo-modal">{i18n.t('certificate.modal12.title')}</h2>
      <div className="project-content">
        <div className="project-image">
          <img src={Certificate} />
        </div>
      </div>
    </div>
  );
};
